import React, { useState } from 'react';
import axios from 'axios';
import { host_url } from '../../../App'; // Import host_url
import BackArrow from '../../../BackArrow'; // Importiere die BackArrow-Komponente

function Selbstständigkeit() {
  const [name, setName] = useState('');
  const [antrag, setAntrag] = useState('');
  const [bereich, setBereich] = useState('');
  const [submissionStatus, setSubmissionStatus] = useState(null); // Add state for submission status

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Name:', name);
    console.log('Antrag:', antrag);
    console.log('Bereich:', bereich);

    axios.post(`${host_url}/selbststaendigkeit`, {
      name,
      antrag,
      bereich
    })
    .then(response => {
      console.log('Data saved:', response.data);
      setSubmissionStatus('success'); // Set submission status to success
    })
    .catch(error => {
      console.error('Error saving data:', error);
      setSubmissionStatus('error'); // Set submission status to error
    });
  };

  return (
    <div>
      <div className="page-header">
        <BackArrow to="/jobportal" />
        <h1>Selbstständigkeit</h1>
      </div>
      {submissionStatus === 'success' && (
        <div>
          <h2>Dein Antrag wurde erfolgreich abgesendet.</h2>
          <button onClick={() => window.location.reload()}>Neuen Antrag stellen</button>
        </div>
      )}
      {submissionStatus === 'error' && (
        <div>
          <h2>Ein Fehler ist aufgetreten. Bitte versuche es erneut.</h2>
          <button className="btn-secondary" onClick={() => setSubmissionStatus(null)}>Zurück</button>
        </div>
      )}
      {submissionStatus === null && (
        <form onSubmit={handleSubmit}>
          <div>
          <label className="freitext-label">Name</label>
            <input
              className="freitext-input"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Nenne deinen Namen"
            />
          </div>
          <div>
          <label className="freitext-label">Antrag</label>
            <textarea
              className="freitext-input"
              value={antrag}
              onChange={(e) => setAntrag(e.target.value)}
              placeholder="Beschreibe deine Geschäftsidee"
            />
          </div>
          <div>
          <label className="freitext-label">Zelt</label>
            <input
              className="freitext-input"
              type="text"
              value={bereich}
              onChange={(e) => setBereich(e.target.value)}
              placeholder="Nenne dein Zelt"
            />
          </div>
          <button type="submit">Absenden</button>
        </form>
      )}
    </div>
  );
}

export default Selbstständigkeit;
